import * as React from 'react';
export const disputeSmartSvg = React.forwardRef(function disputeSmartSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.15 6.518a.435.435 0 0 1 .31.436l-.54 2.67h2.678c.56 0 .919.774.635 1.257l-2.388 4.425c-.079.135-.234.27-.385.27a1.71 1.71 0 0 1-.247-.018c-.191-.057-.355-.252-.299-.492l.575-3.405H8.962c-.56 0-.892-.672-.609-1.154l2.299-3.793a.434.434 0 0 1 .498-.196Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M13 7.015V2.5a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h4.25a.75.75 0 0 1 0 1.5H4a2.5 2.5 0 0 1-2.5-2.5v-11A2.5 2.5 0 0 1 4 0h8a2.5 2.5 0 0 1 2.5 2.5v4.515a.75.75 0 0 1-1.5 0Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.5 7.25a.75.75 0 0 1-.75.75h-1.5a.75.75 0 0 1 0-1.5h1.5a.75.75 0 0 1 .75.75Zm4-3a.75.75 0 0 1-.75.75h-5.5a.75.75 0 0 1 0-1.5h5.5a.75.75 0 0 1 .75.75Z',
    }),
  );
});
disputeSmartSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var disputeSmart = {
  category: 'icon',
  colorable: true,
  name: 'disputeSmart',
  svg: disputeSmartSvg,
};
